var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlipay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.93 21.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.39,15.42c-1.25-.42-2.92-1.06-4.79-1.73a24.83,24.83,0,0,0,2.6-6.56H15.05V4.92h7.54V3.68H15.05V0H12a.52.52,0,0,0-.54.53V3.68H3.81V4.92h7.63V7.13H5.14V8.36H17.35a21.92,21.92,0,0,1-1.76,4.29c-4-1.31-8.19-2.36-10.84-1.71a6.25,6.25,0,0,0-3.44,1.94c-2.95,3.58-.83,9,5.4,9,3.68,0,7.23-2.05,10-5.42,4.1,2,12.22,5.34,12.22,5.34l2-3.72s-3-1.17-7.54-2.67M6.13,19.81c-4.86,0-6.3-3.81-3.9-5.9a6.13,6.13,0,0,1,3.05-1.13c2.88-.28,5.55.82,8.7,2.35C11.77,18,9,19.81,6.13,19.81"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlipay);
export default __webpack_public_path__ + "static/media/alipay.f7bf639f2a52dbedabc1f5d7f47e44ba.svg";
export { ForwardRef as ReactComponent };